import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=2e091061&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=2e091061&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e091061",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e091061')) {
      api.createRecord('2e091061', component.options)
    } else {
      api.reload('2e091061', component.options)
    }
    module.hot.accept("./NotificationBar.vue?vue&type=template&id=2e091061&scoped=true", function () {
      api.rerender('2e091061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commons/NotificationBar.vue"
export default component.exports